<ion-content class="container">
  
  <ion-row class="p-0  headerBreadcrumb">
    <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4" class="center-content">
      <div class="d-flex headerBreadcrumb">
        <img src="././assets/icon/backArrow.svg" class="cp" (click)="onClickBackBtn()">
        <label class="font_semibold fs-16 ml-10 mt-5 black_color">
          <span class="cp" (click)="onClickBackBtn()">Ess</span> / <span
            [style.color]="buttonColorName">Logs</span></label>
      </div>
    </ion-col> 
  </ion-row>

  <ion-row>
    <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
      <div class="center-content p-10">
        <div>
          <mat-form-field class="w-90 mat-height40 mat-input-style">
            <mat-select placeholder="Select Year" [(ngModel)]="selectedYear" (selectionChange)="getessName()">
              <mat-option *ngFor="let item of yearsOfCompany"
                [value]="item.year">{{sharedService.transformYearToFyFormat(item.year)}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div>
          <mat-form-field class="w-100 mat-height40 mat-input-style">
            <mat-select placeholder="Select Survey" [(ngModel)]="selectedSurveyID"
              (selectionChange)="onChangeSurveyLog()">
              <mat-option *ngFor="let item of essNamesList" [value]="item.id">{{item.name}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </ion-col> 
  </ion-row>

  <div class="table-layout">
    <ion-grid class="p-0">
      <div class="tableBox mt-10">
        <ion-row class="p-0">
          <table class="hover">
            <thead class="bg-gray">
              <tr>
                <th class="fs-14 font_bold cl-black" *ngFor="let item of gridData.columnInfo">
                  <div class="verticle-center icon-style">{{item.label}}
                    <div class="d-flex flex-column ml-10" *ngIf="item.label != 'Action'">
                      <i class="material-icons cp" *ngIf="item.propertyName != 'sNo'">arrow_drop_up</i>
                      <i class="material-icons cp" *ngIf="item.propertyName != 'sNo'">arrow_drop_down</i>
                    </div>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody class="bg-white">
              <tr *ngFor="let item of gridData.columnData;let i=index">
                <td class="fs-16 font_regular">
                  <span>{{item.fieldName}}</span>
                </td>
                <td class="fs-16 font_regular">
                  <span >{{item.oldValue}}</span>
                </td>
                <td class="fs-16 font_regular">
                  <span>{{item.newValue}}</span>
                </td>
                <td class="fs-16 font_regular">
                  <span>{{item.lastModifiedBy}}</span>
                </td>
                <td class="fs-16 font_regular">
                  <span>{{item.updatedAt}}</span>
                </td>
                
              </tr>
            </tbody>
          </table>
        </ion-row>
        <!-- <ion-row>
          <ion-col size-sm="8" size-md="8" size-lg="8" size-xs="8" class="center-content">
            <div class="fs-14 font_semibold">Showing 1 to 25 of 50 entries</div>
          </ion-col>
          <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4" class="p-0 text-right display-end">
            <ul class="dt_pagination mt-10 mb-10 mr-10">
              <ion-row class="float-right pgintn">
                <li class="active fs-16 font_regular">1</li>
                <span class="fs-14 font_regular p-10">of 2</span>
                <li class="fs-24 cp" [ngClass]="{'disableBtn': currentPageNumberOfessLogsTable==1}">&lt;</li>
                <li class="fs-24 cp mr-0"
                  [ngClass]="{'disableBtn': currentPageNumberOfessLogsTable >= totalPagesOfessLogsTable}">&gt;
                </li>
              </ion-row>
            </ul>
          </ion-col>
        </ion-row> -->
      </div>
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="display-end">
 
      </ion-col>
      <div class="clear100"></div>
      <div class="clear20"></div>
    </ion-grid>
  </div>
</ion-content>


